/* CYBER RAINDOOR · countdown (usa la hora de inicio en data-cyber-start, formato ISO con zona horaria) */
(function () {
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function init(el) {
    if (el.dataset.cyInit) return;
    el.dataset.cyInit = '1';
    var target = new Date(el.getAttribute('data-cyber-start')).getTime();
    if (isNaN(target)) return;
    var out = {
      d: el.querySelector('[data-cy="d"]'), h: el.querySelector('[data-cy="h"]'),
      m: el.querySelector('[data-cy="m"]'), s: el.querySelector('[data-cy="s"]')
    };
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        el.classList.add('is-live');
        if (el.hasAttribute('data-cy-reload') && !sessionStorageFlag()) location.reload();
        return clearInterval(timer);
      }
      var s = Math.floor(diff / 1000);
      out.d.textContent = pad(Math.floor(s / 86400));
      out.h.textContent = pad(Math.floor(s % 86400 / 3600));
      out.m.textContent = pad(Math.floor(s % 3600 / 60));
      out.s.textContent = pad(s % 60);
    }
    function sessionStorageFlag() {
      try { if (sessionStorage.getItem('cy-reloaded')) return true; sessionStorage.setItem('cy-reloaded', '1'); } catch (e) { return true; }
      return false;
    }
    var timer = setInterval(tick, 1000); tick();
  }
  function boot() { document.querySelectorAll('.cy-countdown').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
